var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar'),_vm._v(" "),_c('buy-art'),_vm._v(" "),_c('div',{staticClass:"padded"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.purchases,"fields":_vm.fields}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58281549","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collectors.vue
// module id = tT28
// module chunks = 1